import { html } from '@microsoft/fast-element';
export const foundationSegmentedItemTemplate = (context, definition) => html `
  <template
    role="radio"
    aria-checked="${(x) => x.checked}"
    aria-required="${(x) => x.required}"
    aria-disabled="${(x) => x.disabled}"
    aria-readonly="${(x) => x.readOnly}"
    @keypress="${(x, c) => x.keypressHandler(c.event)}"
    @click="${(x, c) => x.clickHandler(c.event)}"
  >
    <span>
      <slot></slot>
    </span>
  </template>
`;
